module.exports = __webpack_public_path__ + "static/media/share.3b20594a.png";